import dayjs from 'dayjs';

export function format(date, template) {
  return dayjs(date).format(template);
}
